import { render, staticRenderFns } from "./PenilaianJasmani.vue?vue&type=template&id=25372fc8"
import script from "./PenilaianJasmani.vue?vue&type=script&lang=js"
export * from "./PenilaianJasmani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports